<template>
    <Dropdown
        ref="dropdown"
        :value="value"
        class="w-full"
        :placeholder="placeholder"
        :options="options"
        option-label="name"
        option-value="id"
        :append-to="appendTo"
        @show="$emit('show', $refs.dropdown)"
        @hide="$emit('hide')"
        @change="$emit('input', $event.value)"
    >
        <template #value="slotProps">
            <div v-if="selected" class="flex items-center">
                <img
                    :class="
                        small
                            ? 'w-7 h-7 max-w-7 max-h-7 min-w-7 min-h-7 mr-5'
                            : 'w-8 h-8 max-w-8 max-h-8 min-w-8 min-h-8 mr-4'
                    "
                    :src="src(selected)"
                    :alt="optionName(selected)"
                />
                <span>{{ optionName(selected) }}</span>
            </div>
            <span v-else class="p-placeholder">{{ slotProps.placeholder }}</span>
        </template>
        <template #option="{ option }">
            <div class="flex items-center pointer-events-none text-base">
                <img
                    class="mr-4"
                    :class="small ? 'w-6 h-6 max-w-6 max-h-6 min-w-6 min-h-6' : 'w-8 h-8 max-w-8 max-h-8 min-w-8 min-h-8'"
                    :src="src(option)"
                    :alt="optionName(option)"
                />
                <span>{{ optionName(option) }}</span>
            </div>
        </template>
    </Dropdown>
</template>

<script>
// Dropdown of options shown with an image. `src` maps an option to its image (a require() in the caller,
// so webpack only bundles that folder).
export default {
    name: 'IconSelect',
    props: {
        value: {
            type: [Number, String],
            default: null,
        },
        options: {
            type: Array,
            required: true,
        },
        src: {
            type: Function,
            required: true,
        },
        placeholder: {
            type: String,
            default: null,
        },
        small: {
            type: Boolean,
            default: false,
        },
        appendTo: {
            type: [String, Object],
            default: null,
        },
    },
    emits: ['input', 'show', 'hide'],
    computed: {
        selected() {
            return this.options.find((option) => option.id === this.value) || null;
        },
    },
    methods: {
        // option lists keep `name` (saved with orders) and add `labelKey` for display
        optionName(option) {
            return option.labelKey ? this.$t(option.labelKey) : option.name;
        },
    },
};
</script>

